module.exports = __webpack_public_path__ + "fa-v4compatibility.4bde6a62454b669bb0ce.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fa-v4compatibility.ttf
// module id = ./src/assets/webfonts/fa-v4compatibility.ttf
// module chunks = styles